import * as React from "react";
import { MerchCampaignDebugProps } from "components/flexComponents/MerchCampaign/typings";

export const MerchCampaignDebugInfo = (props: MerchCampaignDebugProps) => {
  const { errorMessage, data } = props;
  const campaignsCount = data?.campaignRecommendations?.campaigns.length ?? 0;
  const campaigns = data?.campaignRecommendations?.campaigns?.map((campaign, index) => (
    <>
      <span title="Campaign ID">{campaign?.campaignId}</span>
      <span title="Offer/Destination Count">
        <strong>({campaign.offers?.length})</strong>
        {index < campaignsCount - 1 && <span>, </span>}
      </span>
    </>
  ));

  const responseId = data?.campaignRecommendations?.responseId;

  return (
    <div className="all-y-padding-two" data-testid="merch-campaign-debug-info">
      <div data-testid="merch-campaign-debug-info-campaigns">
        <strong>Campaigns(Offer/Destination count):</strong> {campaigns ?? "Not available."}
      </div>
      {errorMessage && (
        <div data-testid="merch-campaign-debug-info-error-message">
          <strong>Error Message:</strong> {errorMessage}
        </div>
      )}
      {responseId && (
        <div data-testid="merch-campaign-debug-info-response-id">
          <strong>Response Id:</strong> {responseId}
        </div>
      )}

      {data && (
        <>
          <div data-testid="merch-campaign-debug-response">
            <strong>Response:</strong>
          </div>
          <div>
            <textarea rows={20} style={{ width: "90%" }}>
              {JSON.stringify(data, null, 2)}
            </textarea>
          </div>
        </>
      )}
    </div>
  );
};
